import React from 'react';

import { Group, Progress, Text } from '@mantine/core';

interface IProgressBarCellProps {
  totalCheckins: number;
  required: number;
}

const ProgressBarCell = ({ totalCheckins, required }: IProgressBarCellProps): JSX.Element => {
  // The bar caps at 100% while the count keeps its real value, so over-achievers
  // read as "15/12" rather than an overflowing bar.
  const percent = required > 0 ? Math.min(100, (totalCheckins / required) * 100) : 0;

  return (
    <Group spacing='xs' noWrap>
      <Progress value={percent} size='sm' w={120} />
      <Text size='sm' color='dimmed'>
        {totalCheckins}/{required}
      </Text>
    </Group>
  );
};

export default ProgressBarCell;
